import type { TaskFlowDto } from '@shared/services/apiService';

const validTaskId = /^[A-Za-z0-9_]+$/;

/** Preserve task semantics while giving the copied workflow its own identity. */
export const copyJobWorkflow = (source: TaskFlowDto): TaskFlowDto => {
  const copy = structuredClone(source);
  copy.id = crypto.randomUUID();
  const reserved = new Set(
    copy.tasks.filter((task) => validTaskId.test(task.id)).map((task) => task.id),
  );
  const used = new Set<string>();
  copy.tasks = copy.tasks.map((task, index) => {
    if (validTaskId.test(task.id) && !used.has(task.id)) {
      used.add(task.id);
      return task;
    }
    const stem = task.id.replace(/[^A-Za-z0-9_]/g, '_') || `${task.type}_${index + 1}`;
    let id = stem;
    let suffix = 2;
    while (reserved.has(id) || used.has(id)) id = `${stem}_${suffix++}`;
    used.add(id);
    return { ...task, id };
  });
  return copy;
};
